export { default } from './FeaturedCocktails'
